export function DataChangedAriaLivePolite(props: { message: string }) {
  return (
    <div aria-live='polite' className='sr-only'>
      {props.message}
    </div>
  )
}
